import '../../App.css';
import Seo from '../../components/common/atoms/Seo';
import seoData from '../../json/seo.json';
import textData from '../../json/text.json';
import Header from '../../components/menu/organisms/Header';
import Footer from  '../../components/footer/Footer';
import TopicPath from '../../components/common/atoms/TopicPath';
import H1 from '../../components/common/atoms/H1';
import BackgroundAnimation from '../../components/motion/atoms/BackgroundAnimation';
import PhilosophyContent from '../../components/company/organisms/PhilosophyContent';

/**
 * 経営理念ページ
 * @returns 
 */
function Philosophy() {
  const links = [{link:'/philosophy', pageName:textData['menu.company.philosophy']['ja']}];
  const titleText = textData['menu.company.philosophy']['ja'];
  return (

    <div>
      <BackgroundAnimation />
      <Seo title={titleText} description={seoData.pages.philosophy.description} path='/philosophy' />

      <header>
        <Header />
      </header>
      
      <main className="main-content">
        <TopicPath links={links} />
        <H1 text={titleText}/>
        <PhilosophyContent />
      </main>
      <footer>
        <Footer />
      </footer>

    </div>
  );
}

export default Philosophy;
